<script lang="ts">import { ROUTES } from "../../ts/routes";
import { rm_saved_pool_function } from "../../ts/indexer-db/rm-pools";
//
export let pool;
//
// Function to format fee percentage
function formatFee(fee) {
    return (fee / 100).toFixed(2) + "%";
}
//
function handleRemove() {
    rm_saved_pool_function(pool.id);
    location.reload();
}
</script>

<!-- COMPONENT_POOLS_POOL_INFO_CARD -->
<div class="pool-card">
  <div class="pool-header">
    <h3>POOL #{pool.id}</h3>
    <span class="pool-fee">{formatFee(pool.total_fee)}</span>
  </div>

  <div class="pool-tokens">
    {#each pool.token_account_ids as token}
      <div class="token-item">
        <b class="token-symbol">{token}</b>
      </div>
    {/each}
  </div>
  <div class="pool-links">
    <a href={ROUTES.swap.replace(":pool_id", pool.id)}>TRADE</a>
    <!-- <a href={ROUTES.pool.replace(":pool_id", pool.id)}>DETAILS</a> -->
    <a href={ROUTES.pools} on:click={handleRemove}>🗑️ RM</a>
  </div>
</div>

<style>
  .pool-card {
    border-radius: 8px;
    overflow: hidden;
    background: white;
    color: var(--drk_color_one);
    margin: 5px;
    padding: 0px;
    width: 500px;
    max-width: 90vw;
  }

  .pool-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #eee;
  }

  .pool-header h3 {
    margin: 0;
    font-size: 1.1rem;
  }

  .pool-fee {
    color: var(--alt_color_two);
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 500;
  }

  .pool-tokens {
    margin: 1rem;
    text-align: left;
    font-size: 15px;
  }

  .pool-links {
    display: flex;
    width: 100%;
  }

  .pool-links a {
    flex: 1; /* each link takes equal width */
    text-decoration: none;
    color: var(--drk_color_one);
    background-color: var(--drk_color_one);
    color: white;
    padding: 6px;
    text-align: center; /* center text */
  }

  .pool-links a:hover {
    background-color: white;
    color: var(--drk_color_one);
    border-top: 1px solid var(--drk_color_one);
  }
</style>
